import * as actions from '../actions/agentsList';
import * as ActionTypes from '../actions/index';
import xs from 'xstream';
import BASE_URL from './variables';
import flattenSequentially from 'xstream/extra/flattenSequentially';
import sampleCombine from "xstream/extra/sampleCombine";

export function requestSolicitorUserColleagues(sources) {
	const request$ = sources.ACTION
		.filter(action => action.type === ActionTypes.GET_SOLICITOR_USER_COLLEAGUES)
		.map( action => ({
			url: BASE_URL + `api/users/solicitors/colleagues` ,
			category: 'requestSolicitorUserColleagues',
			method: 'GET',
			withCredentials: true
		}));

	let httpResponse$ = sources.HTTP
		.select('requestSolicitorUserColleagues')
		.map((response) =>
			response.replaceError((err) => xs.of(err))
		)
		.flatten()
		.filter(response => response.status === 200)
		.map(response => actions.getSolicitorUserColleaguesSuccess(response));

	return {
		ACTION: httpResponse$,
		HTTP: request$
	};
}

export function requestSolicitorUserColleaguesFailed(sources) {
	let httpResponse$ = sources.HTTP
		.select('requestSolicitorUserColleagues')
		.map((response) =>
			response.replaceError((err) => xs.of(err))
		)
		.flatten()
		.filter(response => response.status !== 200)
		.map(response => actions.getSolicitorUserColleaguesFailed(response));

	return {
		ACTION: httpResponse$
	}
}

export function getSolicitors(sources) {

	//below the request$ describes to the HTTP Cycle driver what http request to make and the requests details
	const request$ = sources.ACTION
		.filter(action => action.type === ActionTypes.REQUEST_GET_SOLICITORS)
		.map(action => ({
			url: BASE_URL + 'api/users/solicitors?limit='+ action.payload.limit +
			'&offset=' + action.payload.offset +
			'&lawsysId=' + action.payload.lawsysId +
			(action.payload.search !==null? '&search=' + action.payload.search:'') +
            (action.payload.orderAsc? '&orderAsc=' + action.payload.orderAsc:'') +
            (action.payload.orderBySolicitorName? '&orderBySolicitorName=' + action.payload.orderBySolicitorName:'') +
            (action.payload.orderByLawsysId? '&orderByLawsysId=' + action.payload.orderByLawsysId:'') +
            (action.payload.orderByLawsysName? '&orderByLawsysName=' + action.payload.orderByLawsysName:'') +
            (action.payload.orderByUserName? '&orderByUserName=' + action.payload.orderByUserName:'') +
            (action.payload.includeLinkedFirms? '&includeLinkedFirms=true':''),
			category: 'getSolicitors',
			method: 'GET',
			withCredentials: true
		}));

	//below httpResponse$ listens  for http responses and after filtering ,in order to get
	//the successful http get requests, it updates the redux store with the lawsys agents
	let httpResponse$ = sources.HTTP
		.select('getSolicitors')
		.map((response) =>
			response.replaceError((err) => xs.of(err))
		)
		.flatten()
		.filter(response => response.status === 200)
		.map(response => actions.receiveGetSolicitors(JSON.parse(response.text)));

	return {
		ACTION: httpResponse$,
		HTTP: request$
	};
}

export function failedGetSolicitors(sources) {
	let httpResponse$ = sources.HTTP
		.select('getSolicitors')
		.map((response) =>
			response.replaceError((err) => xs.of(err))
		)
		.flatten()
		.filter(response => response.status !== 200)
		.map(response => actions.receiveBadRequestGetSolicitors(response));

    return {
        ACTION: httpResponse$
    }
}

export function getSolicitorsSuggestions(sources) {

	//below the request$ describes to the HTTP Cycle driver what http request to make and the requests details
	const request$ = sources.ACTION
		.filter(action => action.type === ActionTypes.REQUEST_GET_SOLICITORS_SUGGESTIONS)
		.map(action => ({
			url: BASE_URL + 'api/users/solicitors?limit='+ action.payload.limit +
			'&offset=' + action.payload.offset +
			'&lawsysId=' + action.payload.lawsysId +
			(action.payload.search !==null? '&search=' + action.payload.search:'') +
            (action.payload.orderAsc? '&orderAsc=' + action.payload.orderAsc:'') +
            (action.payload.orderBySolicitorName? '&orderBySolicitorName=' + action.payload.orderBySolicitorName:'') +
            (action.payload.orderByLawsysId? '&orderByLawsysId=' + action.payload.orderByLawsysId:'') +
            (action.payload.orderByLawsysName? '&orderByLawsysName=' + action.payload.orderByLawsysName:'') +
            (action.payload.orderByUserName? '&orderByUserName=' + action.payload.orderByUserName:''),
			category: 'getSolicitorsSuggestions',
			method: 'GET',
			withCredentials: true
		}));

	//below httpResponse$ listens  for http responses and after filtering ,in order to get
	//the successful http get requests, it updates the redux store with the lawsys agents
	let httpResponse$ = sources.HTTP
		.select('getSolicitorsSuggestions')
		.map((response) =>
			response.replaceError((err) => xs.of(err))
		)
        .compose(flattenSequentially)
		.filter(response => response.status === 200)
		.map(response => actions.receiveGetSolicitorsSuggestions(JSON.parse(response.text)));

	return {
		ACTION: httpResponse$,
		HTTP: request$
	};
}

export function failedGetSolicitorsSuggestions(sources) {
	let httpResponse$ = sources.HTTP
		.select('getSolicitorsSuggestions')
		.map((response) =>
			response.replaceError((err) => xs.of(err))
		)
		.flatten()
		.filter(response => response.status !== 200)
		.map(response => actions.receiveBadRequestGetSolicitorsSuggestions(response));

    return {
        ACTION: httpResponse$
    }
}

